import {client} from './services/webservices-client'

export const transfers = {
    namespaced: true,
    state: {
        transfers: undefined,
        transfer:undefined,
    },
    mutations: {
        SET_TRANSFERS(state, transfers) {
            state.transfers = transfers
        },
        SET_TRANSFER(state, transfer) {
            state.transfer = transfer
        },


    },
    actions: {
        getTransfer({commit}, data) {
            return new Promise((resolve, reject) => {
                client({
                    method: 'get',
                    url: '/v1/transfers/get/'+data.type+'/'+data.id,
                }).then((response) => {
                        commit('SET_TRANSFERS', response.data.transfers);
                      resolve(response)

                }).catch((error) => {
                        reject(error);
                    })
            })

        },

        setTransfer({commit}, data) {
            return new Promise((resolve, reject) => {
                client({
                    method: 'post',
                    url: '/v1/transfers/perform',
                    data: data,
                }).then((response) => {
                        commit('SET_TRANSFER', response.data.transfer);
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            });
        }
    },
    getters: {
        getTransfer: state => {
            return state.transfers
        },


    }
};
